export default __webpack_public_path__ + "static/media/cycle_list_left.82cf83b2.png";